document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu toggle
  var nav = document.getElementById('main-nav');
  var toggle = document.getElementById('menu-toggle');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  // Quantity stepper on product page (visual +/- for the number input)
  document.querySelectorAll('[data-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.qty-stepper');
      if (!wrap) return;
      var input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      var delta = parseInt(btn.getAttribute('data-qty-step'), 10);
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = Math.max(min, (parseInt(input.value, 10) || min) + delta);
      input.value = next;
    });
  });

  // Variant picker: pill buttons per option, updates hidden variant id + price
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var variantsDataEl = document.getElementById(form.getAttribute('data-variants-json'));
  if (!variantsDataEl) return;
  var variants;
  try { variants = JSON.parse(variantsDataEl.textContent); } catch (e) { return; }

  var idInput = form.querySelector('input[name="id"]');
  var submitBtn = form.querySelector('[data-add-to-cart]');
  var priceEl = document.querySelector('[data-price]');
  var compareEl = document.querySelector('[data-compare-price]');
  var stockNote = document.querySelector('[data-stock-note]');
  var moneyFormat = form.getAttribute('data-money-format') || '{{amount}} ₺';

  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 });
    return moneyFormat.replace('{{amount}}', amount);
  }

  function currentSelection() {
    var selected = [];
    form.querySelectorAll('.variant-options').forEach(function (group) {
      var sel = group.querySelector('.variant-btn.selected');
      selected.push(sel ? sel.getAttribute('data-value') : null);
    });
    return selected;
  }

  function findVariant(selection) {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selection[i]; });
    });
  }

  function updateForSelection() {
    var selection = currentSelection();
    var variant = findVariant(selection);
    if (!variant) return;

    idInput.value = variant.id;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (variant.available) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.getAttribute('data-label-available') || 'Sepete Ekle'; }
      if (stockNote) stockNote.style.display = 'none';
    } else {
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Stokta Yok'; }
      if (stockNote) stockNote.style.display = '';
    }
  }

  form.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.variant-options');
      group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      updateForSelection();
    });
  });

  updateForSelection();
});
